import {NgModule} from '@angular/core';
import {DateBeforeValidator} from './date-before-validator.directive';
import {FutureDateValidator} from './future-date-validator.directive';
import {OnlyWhitespaceValidator} from './only-whitespace-validator.directive';
import {NumberValidator} from './number-validator.directive';
import {CustomEmailValidator} from './custom-email-validator.directive';


@NgModule({
  declarations: [
    DateBeforeValidator,
    FutureDateValidator,
    NumberValidator,
    OnlyWhitespaceValidator,
    CustomEmailValidator
  ],
  imports: [],
  exports: [
    DateBeforeValidator,
    FutureDateValidator,
    NumberValidator,
    OnlyWhitespaceValidator,
    CustomEmailValidator,
  ]
})

export class ValidatorsModule {
}
